import React, { useState } from 'react';
import { MessageSquare, Star, Send } from 'lucide-react';

const FeedbackPage: React.FC = () => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Google Formsのような外部サービスに送信するロジックをここに追加
    console.log({
      rating,
      feedback,
      email,
      timestamp: new Date().toISOString()
    });
    
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-6">
            <div className="bg-green-100 rounded-full p-3 w-16 h-16 mx-auto mb-4">
              <Send className="h-10 w-10 text-green-600 mx-auto" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              フィードバックありがとうございます！
            </h2>
            <p className="text-gray-600">
              いただいたご意見は今後のサービス改善に活用させていただきます。
            </p>
          </div>
          
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <p className="text-blue-800 font-semibold">特典をプレゼント！</p>
            <p className="text-blue-600 text-sm mt-1">
              フィードバック提供の特典として、Basic プラン1ヶ月無料クーポンを
              ご登録のメールアドレスに送付いたします。
            </p>
          </div>
          
          <button
            onClick={() => window.location.href = '/dashboard'}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition"
          >
            ダッシュボードに戻る
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <MessageSquare className="h-16 w-16 text-blue-600 mx-auto mb-4" />
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              フィードバックをお聞かせください
            </h1>
            <p className="text-gray-600">
              ContentCraft AIをより良いサービスにするため、ご意見をお聞かせください。
              フィードバックをお寄せいただいた方には特典をご用意しています。
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">
                ContentCraft AIの使いやすさはいかがでしたか？
              </label>
              <div className="flex items-center space-x-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    onClick={() => setRating(star)}
                    className={`p-1 rounded ${
                      star <= rating ? 'text-yellow-400' : 'text-gray-300'
                    } hover:text-yellow-400 transition-colors`}
                  >
                    <Star className="h-8 w-8 fill-current" />
                  </button>
                ))}
                <span className="ml-3 text-sm text-gray-600">
                  {rating > 0 && (
                    rating === 5 ? '最高です！' :
                    rating === 4 ? '良好です' :
                    rating === 3 ? '普通です' :
                    rating === 2 ? '改善の余地あり' :
                    '使いにくいです'
                  )}
                </span>
              </div>
            </div>

            <div>
              <label htmlFor="feedback" className="block text-sm font-medium text-gray-700 mb-2">
                具体的なご意見・ご要望（任意）
              </label>
              <textarea
                id="feedback"
                rows={6}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="例：
• 使いにくかった点
• 追加してほしい機能
• 生成された内容の品質について
• その他のご要望"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                メールアドレス（特典送付用）
              </label>
              <input
                type="email"
                id="email"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <p className="text-sm text-gray-500 mt-1">
                フィードバック特典（Basic プラン1ヶ月無料）の送付に使用します
              </p>
            </div>

            <div className="bg-blue-50 rounded-lg p-4">
              <h3 className="font-semibold text-blue-900 mb-2">🎁 フィードバック特典</h3>
              <ul className="text-blue-800 text-sm space-y-1">
                <li>• Basic プラン1ヶ月無料（通常 ¥1,000）</li>
                <li>• 新機能の先行アクセス</li>
                <li>• プロダクト開発への参加権</li>
              </ul>
            </div>

            <button
              type="submit"
              disabled={rating === 0 || !email}
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed font-semibold"
            >
              フィードバックを送信
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPage;